import { render, staticRenderFns } from "./TopFeatures.vue?vue&type=template&id=9a1b63e2"
import script from "./TopFeatures.vue?vue&type=script&lang=js"
export * from "./TopFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports